<div class="flex flex-col gap-6">
  <span class="text-xl font-bold">Datos económicos</span>

  <div class="grid grid-cols-2 gap-4">
    <div class="col-span-2 grid grid-cols-2 gap-4 items-start">
      <div class="flex flex-col gap-3">
        <div class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('totalPeopleBefore')"
            (change)="reviewFields.toggleField('totalPeopleBefore')" />

          <div class="flex flex-col">
            <div class="flex items-center gap-2">
              <span class="text-sm text-neutral-dark">Total de empleados públicos antes del despliegue</span>
              <app-tooltip
                *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('totalPeopleBefore')"
                class="-mt-2"
                [description]="previousReviewText('totalPeopleBefore')"
                tipeIcon="info" />
            </div>
            <span class="text-md font-semibold">
              {{ formatValues(project?.totalPeopleBefore) }}
            </span>
          </div>
        </div>

        <div class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('groupAdministrationBefore')"
            (change)="reviewFields.toggleField('groupAdministrationBefore')" />

          <div class="flex flex-col">
            <div class="flex items-center gap-2">
              <span class="text-sm text-neutral-dark">Grupo de administración antes del despliegue</span>
              <app-tooltip
                *ngIf="
                  reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('groupAdministrationBefore')
                "
                class="-mt-2"
                [description]="previousReviewText('groupAdministrationBefore')"
                tipeIcon="info" />
            </div>
            <span class="text-md font-semibold">
              {{ formatValues(project?.groupAdministrationBefore) }}
            </span>
          </div>
        </div>

        <div class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('levelPositionBefore')"
            (change)="reviewFields.toggleField('levelPositionBefore')" />

          <div class="flex flex-col">
            <div class="flex items-center gap-2">
              <span class="text-sm text-neutral-dark">Nivel de puesto antes del despliegue</span>
              <app-tooltip
                *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('levelPositionBefore')"
                class="-mt-2"
                [description]="previousReviewText('levelPositionBefore')"
                tipeIcon="info" />
            </div>
            <span class="text-md font-semibold">
              {{ formatValues(project?.levelPositionBefore) }}
            </span>
          </div>
        </div>
      </div>

      <div class="flex flex-col gap-3">
        <div class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('totalPeopleAfter')"
            (change)="reviewFields.toggleField('totalPeopleAfter')" />

          <div class="flex flex-col">
            <div class="flex items-center gap-2">
              <span class="text-sm text-neutral-dark">Total de empleados públicos tras el despliegue</span>
              <app-tooltip
                *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('totalPeopleAfter')"
                class="-mt-2"
                [description]="previousReviewText('totalPeopleAfter')"
                tipeIcon="info" />
            </div>
            <span class="text-md font-semibold">
              {{ formatValues(project?.totalPeopleAfter) }}
            </span>
          </div>
        </div>

        <div class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('groupAdministrationAfter')"
            (change)="reviewFields.toggleField('groupAdministrationAfter')" />

          <div class="flex flex-col">
            <div class="flex items-center gap-2">
              <span class="text-sm text-neutral-dark">Grupo de administración tras el despliegue</span>
              <app-tooltip
                *ngIf="
                  reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('groupAdministrationAfter')
                "
                class="-mt-2"
                [description]="previousReviewText('groupAdministrationAfter')"
                tipeIcon="info" />
            </div>
            <span class="text-md font-semibold">
              {{ formatValues(project?.groupAdministrationAfter) }}
            </span>
          </div>
        </div>

        <div class="flex gap-3 items-start">
          <input
            *ngIf="reviewMode && !readonlyReview"
            type="checkbox"
            class="mt-1"
            [checked]="reviewFields.isFieldMarked('levelPositionAfter')"
            (change)="reviewFields.toggleField('levelPositionAfter')" />

          <div class="flex flex-col">
            <div class="flex items-center gap-2">
              <span class="text-sm text-neutral-dark">Nivel de puesto tras el despliegue</span>
              <app-tooltip
                *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('levelPositionAfter')"
                class="-mt-2"
                [description]="previousReviewText('levelPositionAfter')"
                tipeIcon="info" />
            </div>
            <span class="text-md font-semibold">
              {{ formatValues(project?.levelPositionAfter) }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('amountAffectedCitizens')"
        (change)="reviewFields.toggleField('amountAffectedCitizens')" />

      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          <span class="text-sm text-neutral-dark">Número de personas afectadas por el proceso (ciudadanos)</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('amountAffectedCitizens')"
            class="-mt-2"
            [description]="previousReviewText('amountAffectedCitizens')"
            tipeIcon="info" />
        </div>
        <span class="text-md font-semibold">
          {{ project?.amountAffectedCitizens || '-' }}
        </span>
      </div>
    </div>
    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('amountAffectedOfficials')"
        (change)="reviewFields.toggleField('amountAffectedOfficials')" />

      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          <span class="text-sm text-neutral-dark">Numero de personas afectadas por el proceso (funcionarios)</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('amountAffectedOfficials')"
            class="-mt-2"
            [description]="previousReviewText('amountAffectedOfficials')"
            tipeIcon="info" />
        </div>
        <span class="text-md font-semibold">
          {{ project?.amountAffectedOfficials || '-' }}
        </span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('economicEstimateImplementation')"
        (change)="reviewFields.toggleField('economicEstimateImplementation')" />

      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          <span class="text-sm text-neutral-dark">Estimación económica de implantación</span>
          <app-tooltip
            *ngIf="
              reviewMode &&
              showPreviousReviewIndicators &&
              reviewFields.hasPreviousReview('economicEstimateImplementation')
            "
            class="-mt-2"
            [description]="previousReviewText('economicEstimateImplementation')"
            tipeIcon="info" />
        </div>
        <span class="text-md font-semibold">{{ project?.economicEstimateImplementation | economicAmount }}</span>
      </div>
    </div>
    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('economicEstimateAnnualMaintenance')"
        (change)="reviewFields.toggleField('economicEstimateAnnualMaintenance')" />
      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          <span class="text-sm text-neutral-dark">Estimación económica de mantenimiento anual</span>
          <app-tooltip
            *ngIf="
              reviewMode &&
              showPreviousReviewIndicators &&
              reviewFields.hasPreviousReview('economicEstimateAnnualMaintenance')
            "
            class="-mt-2"
            [description]="previousReviewText('economicEstimateAnnualMaintenance')"
            tipeIcon="info" />
        </div>
        <span class="text-md font-semibold">{{ project?.economicEstimateAnnualMaintenance | economicAmount }}</span>
      </div>
    </div>
    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('economicEstimateConsumption')"
        (change)="reviewFields.toggleField('economicEstimateConsumption')" />

      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          <span class="text-sm text-neutral-dark">Estimación económica de consumo</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('economicEstimateConsumption')"
            class="-mt-2"
            [description]="previousReviewText('economicEstimateConsumption')"
            tipeIcon="info" />
        </div>
        <span class="text-md font-semibold">{{ project?.economicEstimateConsumption | economicAmount }}</span>
      </div>
    </div>
    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('currentApplicationCostEstimate')"
        (change)="reviewFields.toggleField('currentApplicationCostEstimate')" />

      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          <span class="text-sm text-neutral-dark">Estimación del coste de aplicación actual</span>
          <app-tooltip
            *ngIf="
              reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('currentApplicationCostEstimate')
            "
            class="-mt-2"
            [description]="previousReviewText('currentApplicationCostEstimate')"
            tipeIcon="info" />
        </div>
        <span class="text-md font-semibold">{{ project?.currentApplicationCostEstimate | economicAmount }}</span>
      </div>
    </div>
    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('otherDerivedCosts')"
        (change)="reviewFields.toggleField('otherDerivedCosts')" />

      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          <span class="text-sm text-neutral-dark">Otros costes derivados</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('otherDerivedCosts')"
            class="-mt-2"
            [description]="previousReviewText('otherDerivedCosts')"
            tipeIcon="info" />
        </div>

        <span class="text-md font-semibold">{{ project?.otherDerivedCosts | economicAmount }}</span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('currentStaffCostEstimate')"
        (change)="reviewFields.toggleField('currentStaffCostEstimate')" />

      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          <span class="text-sm text-neutral-dark">Estimación del coste de personal actual</span>
          <app-tooltip
            *ngIf="reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('currentStaffCostEstimate')"
            class="-mt-2"
            [description]="previousReviewText('currentStaffCostEstimate')"
            tipeIcon="info" />
        </div>

        <span class="text-md font-semibold">{{ project?.currentStaffCostEstimate | economicAmount }}</span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('averageResolutionEstimateTime')"
        (change)="reviewFields.toggleField('averageResolutionEstimateTime')" />

      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          <span class="text-sm text-neutral-dark">Plazo medio de resolución antes del despliegue (en meses)</span>
          <app-tooltip
            *ngIf="
              reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('averageResolutionEstimateTime')
            "
            class="-mt-2"
            [description]="previousReviewText('averageResolutionEstimateTime')"
            tipeIcon="info" />
        </div>
        <span class="text-md font-semibold">
          {{ project?.averageResolutionEstimateTime || '-' }}
        </span>
      </div>
    </div>

    <div class="flex gap-3 items-start">
      <input
        *ngIf="reviewMode && !readonlyReview"
        type="checkbox"
        class="mt-1"
        [checked]="reviewFields.isFieldMarked('averageResolutionRealTime')"
        (change)="reviewFields.toggleField('averageResolutionRealTime')" />

      <div class="flex flex-col">
        <div class="flex items-center gap-2">
          <span class="text-sm text-neutral-dark">Plazo medio de resolución después del despliegue (en meses)</span>
          <app-tooltip
            *ngIf="
              reviewMode && showPreviousReviewIndicators && reviewFields.hasPreviousReview('averageResolutionRealTime')
            "
            class="-mt-2"
            [description]="previousReviewText('averageResolutionRealTime')"
            tipeIcon="info" />
        </div>
        <span class="text-md font-semibold">
          {{ project?.averageResolutionRealTime || '-' }}
        </span>
      </div>
    </div>
  </div>
</div>
